var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarningLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "5px",
    height: "18px",
    viewBox: "0 0 5 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-511.000000, -189.000000)",
    fill: "#DCA00E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M515.25,205.125 C515.25,204.089466 514.410534,203.25 513.375,203.25 C512.339466,203.25 511.5,204.089466 511.5,205.125 C511.5,206.160534 512.339466,207 513.375,207 C514.410534,207 515.25,206.160534 515.25,205.125 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.015869,189 L514.734131,189 C515.010273,189 515.234131,189.223858 515.234131,189.5 C515.234131,189.505207 515.23405,189.510413 515.233887,189.515617 L514.890137,200.515617 C514.881702,200.785548 514.660443,201 514.390381,201 L512.359619,201 C512.089557,201 511.868298,200.785548 511.859863,200.515617 L511.516113,189.515617 C511.507488,189.23961 511.724244,189.008869 512.000252,189.000244 C512.005456,189.000081 512.010662,189 512.015869,189 Z",
    id: "Rectangle"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningLogo);
export default __webpack_public_path__ + "static/media/warning_logo.40dbc145b519187af6b91732b3a9d236.svg";
export { ForwardRef as ReactComponent };